import { useState } from 'react';
import { Shield } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue }
  from '@/components/ui/select';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { usePerfisLista, usePermissoesPerfil }
  from '@/features/permissoes/hooks/usePermissoesPerfil';
import { TabelaPermissoes }
  from '@/features/permissoes/components/TabelaPermissoes';
import type { PermissaoFormulario } from '@/features/permissoes/types';

export default function ConfiguracaoPerfil() {
  const [perfilId, setPerfilId] = useState<number | null>(null);

  const { perfis }                                       = usePerfisLista();
  const { gruposPorMenu, isLoading, salvarPermissao, salvarPorMenu }
                                                         = usePermissoesPerfil(perfilId);

  function handleAlterarPermissao(
    formularioId: number,
    campo: keyof Pick<PermissaoFormulario, 'podeLer' | 'podeIncluir' | 'podeEditar' | 'podeExcluir'>,
    valor: boolean
  ) {
    const formulario = gruposPorMenu
      .flatMap(g => g.formularios)
      .find(f => f.formularioId === formularioId);
    if (!formulario) return;

    salvarPermissao({
      formularioId,
      permissao: { ...formulario, [campo]: valor },
    });
  }

  return (
    <div className="p-6 space-y-6">
      <div className="flex items-center gap-2">
        <Shield className="h-6 w-6 text-primary" />
        <h1 className="text-2xl font-bold">Configuração de Perfis de Acesso</h1>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="text-base">Perfil</CardTitle>
        </CardHeader>
        <CardContent>
          <Select
            value={perfilId?.toString() ?? ''}
            onValueChange={v => setPerfilId(Number(v))}
          >
            <SelectTrigger className="w-72">
              <SelectValue placeholder="Selecione um perfil..." />
            </SelectTrigger>
            <SelectContent>
              {perfis.map(p => (
                <SelectItem key={p.id} value={p.id.toString()}>
                  {p.nome}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </CardContent>
      </Card>

      {perfilId && (
        <Card>
          <CardContent className="pt-4">
            {isLoading ? (
              <div className="flex justify-center py-10">
                <div className="h-8 w-8 animate-spin rounded-full
                                border-4 border-primary border-t-transparent" />
              </div>
            ) : (
              <Tabs defaultValue={gruposPorMenu[0]?.menuId.toString()}>
                <TabsList className="flex-wrap h-auto gap-1 mb-4">
                  {gruposPorMenu.map(g => (
                    <TabsTrigger key={g.menuId} value={g.menuId.toString()}>
                      {g.nomeMenu}
                    </TabsTrigger>
                  ))}
                </TabsList>

                {gruposPorMenu.map(g => (
                  <TabsContent key={g.menuId} value={g.menuId.toString()}>
                    <TabelaPermissoes
                      grupo={g}
                      onToggleTudo={(menuId, concederTudo) =>
                        salvarPorMenu({ menuId, concederTudo })}
                      onAlterarPermissao={handleAlterarPermissao}
                    />
                  </TabsContent>
                ))}
              </Tabs>
            )}
          </CardContent>
        </Card>
      )}
    </div>
  );
}
